import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import { PolicyCoverageResponse } from './types'
import { useDebounce } from '@/hooks/useDebounce'

const fetchPolicyCoverage = async (identityId: string) => {
  const response = await httpClientPrivate.get<PolicyCoverageResponse>(
    `${config.restUrl}/v1/backoffice/health-claim/policy-coverage/${identityId}`,
  )

  return response.data
}

const usePolicyCoverage = (identityId: string) => {
  // Debounce the identityId with 1 second delay
  const debouncedIdentityId = useDebounce(identityId, 1000)

  // Use debouncedIdentityId in the query
  const queryKey = ['usePolicyCoverage', debouncedIdentityId]
  const queryFn = async () => fetchPolicyCoverage(debouncedIdentityId)
  const queryResult = useQuery({ queryKey, queryFn, enabled: !!debouncedIdentityId })

  return { ...queryResult }
}

export { fetchPolicyCoverage, usePolicyCoverage }
